import React from "react";

export default function ArticleBlock({ data }) {
	function showContent() {
		switch (data.type) {
			case 1:
				return (
					<div className="topic-list">
						{data.content.map((c) => (
							<li>{c}</li>
						))}
					</div>
				);
			case 2:
				return (
					<div className="numeric-list">
						{data.content.map((c) => (
							<li>{c}</li>
						))}
					</div>
				);
			case 3:
				return (
					<div className="article-image">
						{!data.content ? <></> : <img src={data.content} alt=" " />}
					</div>
				);
			case 4:
				return (
					<div className="article-video">
						<iframe
							src={data.content}
							frameborder="0"
							allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
							title="video"
							referrerPolicy="strict-origin-when-cross-origin"></iframe>
					</div>
				);
			default:
				console.error("tipagem de topicos errada");
				break;
		}
	}

	return (
		<div>
			<h2>{data.name}</h2>
			<p>{data.description}</p>
			<ul>{showContent()}</ul>
		</div>
	);
}
